// One copy-to-clipboard for the whole app.
//
// The Clipboard API is refused in some places (sandboxed iframes, insecure
// contexts, a tap that lost its user-gesture grant), so the legacy
// selection + execCommand path is the fallback. Never rejects: callers show
// their "Copied" confirmation on resolve either way, so the tap always
// visibly registers.
export function copyTextToClipboard(text: string): Promise<void> {
  const legacyCopy = () => {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    } catch {
      /* even the fallback can fail — the caller's confirmation still fires */
    }
  };
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text).catch(() => legacyCopy());
  }
  legacyCopy();
  return Promise.resolve();
}
